import {
  createEvent,
  createStore,
  Effect,
  Store,
  Event,
  forward,
  guard,
  sample,
  split,
  merge
} from 'effector';

type Units = Event<any> | Store<any> | Effect<any, any>;

export const createSequence = (...units: Units[]) => {
  const event = createEvent();
  const $flags = createStore(Array.from({ length: units.length }).fill(false));
  const changeFlag = createEvent<number>();
  const reset = createEvent();
  $flags
    .on(changeFlag, (s, index) => s.map((x, i) => (i === index ? true : x)))
    .reset(reset, event);

  for (let i = 0; i < units.length; i++) {
    const unit = units[i];
    const unitEvent = createEvent();
    forward({ from: unit, to: unitEvent });
    const onUnitEvent = split(sample($flags, unitEvent), {
      isFirst: () => i === 0,
      isValid: x => i > 0 && x[i - 1] === true,
      isNotValid: x => i > 0 && x[i - 1] === false
    });

    forward({
      from: onUnitEvent.isNotValid,
      to: reset
    });
    forward({
      from: merge([onUnitEvent.isFirst, onUnitEvent.isValid]).map(() => i),
      to: changeFlag
    });
  }

  forward({
    from: guard($flags, { filter: x => x.filter(Boolean).length === x.length }),
    to: event
  });

  return event;
};
